module.exports = __webpack_public_path__ + "public/img/公共广播Bg.61360db2.png";